import { Injectable } from '@angular/core';
import { AuthUser } from '../interfaces/authUser';
import { Storage } from '@ionic/storage-angular';
import {
  APP_CONFIG,
  APP_NOTIFICATION,
  CHAT_MESSAGE,
  CHAT_PAGE,
  COMPANY_COUNTRIES,
  COUNTRY_GATEWAY_PAGE_CODE,
  DEVICE_INFO,
  URL_CONFIG,
} from '../interfaces/constants';
import { Device } from '@capacitor/device';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Observable, Subject } from 'rxjs';
import { from } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  authUser: AuthUser;
  isOnline = true;
  chatNewMessage = new Subject();
  chatNewNotification = new Subject();
  appNotification = new Subject();

  constructor(private storage: Storage, private http: HttpClient) {}

  getRemoteConfig(): Observable<any> {
    return this.http.get(URL_CONFIG);
  }

  saveLocalConfig(config: any) {
    return from(
      new Promise((resolve) =>
        resolve(localStorage.setItem(APP_CONFIG, JSON.stringify(config)))
      )
    );
  }

  getLocalConfig() {
    return JSON.parse(localStorage.getItem(APP_CONFIG));
  }

  refreshConfig() {
    this.getRemoteConfig().subscribe((config) =>
      this.saveLocalConfig(config).subscribe({ complete: () => true })
    );
  }

  getDeviceInfo() {
    const logDeviceInfo = async () => await Device.getInfo();
    logDeviceInfo().then((data) => {
      const deviceInfo = {
        osName: data.platform,
        osVersion: data.osVersion,
        appVersion: '1.9.12',
      };
      localStorage.setItem(DEVICE_INFO, JSON.stringify(deviceInfo));
    });
  }

  async init() {
    await LocalNotifications.requestPermissions();
    LocalNotifications.schedule({
      notifications: [
        {
          id: 1,
          title: 'Hello',
          body: 'World',
        },
      ],
    });

    LocalNotifications.addListener(
      'localNotificationActionPerformed',
      (payload) => {}
    );
  }

  deleteCountryGatewayPage(): Observable<any> {
    return from(this.storage.remove(COUNTRY_GATEWAY_PAGE_CODE));
  }

  saveCountryGatewayPage(): Observable<any> {
    return from(this.storage.set(COUNTRY_GATEWAY_PAGE_CODE, true));
  }

  getCountryGateway() {
    return JSON.parse(localStorage.getItem(COMPANY_COUNTRIES));
  }
}
